
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

// Create an instance of axios with default settings
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor to include the token in the headers
axiosInstance.interceptors.request.use(
  (config) => {
  const token = localStorage.getItem('userToken');
    if (token) {
      config.headers["x-access-token"] = token; // Set the token in the header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export const createEvent = async (payload) => {
  try {
    const response = await axiosInstance.post("/createEvent",payload);
    return response.data;
  } catch (error) {
    console.error("createEvent API Error:", error);
    throw error;
  }
};
export const editEvent = async (payload) => {
  try {
    const response = await axiosInstance.post("/editEvent",payload);
    return response.data;
  } catch (error) {
    console.error("editEvent API Error:", error);
    throw error;
  }
};
export const getCommunityEvents = async (payload) => {
  try {
    const response = await axiosInstance.post("/getCommunityEvents",payload);
    return response.data;
  } catch (error) {
    console.error("getCommunityEvents API Error:", error);
    throw error;
  }
};
export const getOrganizationEvents = async (payload) => {
  try {
    const response = await axiosInstance.post("/getOrganizationEvents",payload);
    return response.data;
  } catch (error) {
    console.error("getOrganizationEvents API Error:", error);
    throw error;
  }
};
export const attendEvent = async (payload) => {
  try {
    const response = await axiosInstance.post("/attendEvent",payload);
    return response.data;
  } catch (error) {
    console.error("attendEvent API Error:", error);
    throw error;
  }
};
export const getEventDetails = async (payload) => {
  try {
    const response = await axiosInstance.post("/getEventDetails",payload);
    return response.data;
  } catch (error) {
    console.error("getEventDetails API Error:", error);
    throw error;
  }
};
export const getAllEventPlaces = async (payload) => {
  try {
    const response = await axiosInstance.post("/getAllEventPlaces",payload);
    return response.data;
  } catch (error) {
    console.error("getAllEventPlaces API Error:", error);
    throw error;
  }
};
export const deleteEvent = async (payload) => {
  try {
    const response = await axiosInstance.post("/deleteEvent",payload);
    return response.data;
  } catch (error) {
    console.error("deleteEvent API Error:", error);
    throw error;
  }
};













